import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import PreviewGate from "@/PreviewGate";

const container = document.getElementById("root");
// Prerendered builds ship a static SEO snapshot inside #root for crawlers.
// It is a lightweight shell (not an exact render), so we replace it rather than hydrate.
if (container.hasChildNodes()) {
  container.innerHTML = "";
}

const root = ReactDOM.createRoot(container);
// Service worker: makes the app installable and keeps it usable when the phone drops offline.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

root.render(
  <React.StrictMode>
    <PreviewGate>
      <App />
    </PreviewGate>
  </React.StrictMode>,
);
